<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-md-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-md-0 me-auto">Kondisi Kejiwaan</h5>

              <template v-if="userId != ''">
                <router-link
                  :to="`/message?userId=${userId}`"
                  class="btn btn btn-outline-success mb-1 mb-sm-0"
                >Pesan</router-link>
                <router-link
                  :to="`/user-schedules?userId=${userId}`"
                  class="btn btn btn-outline-success mb-1 mb-sm-0"
                >Penjadwalan</router-link>
                <router-link
                  :to="`/psychology?userId=${userId}`"
                  class="btn btn btn-outline-success mb-1 mb-sm-0"
                >Kondisi Kejiwaan</router-link>

                <div class="dropdown d-inline-block">
                  <a
                    class="btn btn-primary dropdown-toggle mb-1 mb-sm-0"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >Kelola</a>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`user-examination?userId=${userId}`"
                      >Riwayat Pemeriksaan</router-link>
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`user-pregnancies?userId=${userId}`"
                      >Daftar Profil Kehamilan</router-link>
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`user-assessment?userId=${userId}`"
                      >Assessment</router-link>
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`report?userId=${userId}`"
                      >Laporan</router-link>
                    </li>
                    <li>
                      <hr class="my-2">
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`form-examination?userId=${userId}`"
                      >Tambah Pemeriksaan</router-link>
                    </li>
                    <li>
                      <router-link
                        class="dropdown-item"
                        :to="`form-maternity?userId=${userId}`"
                      >Tambah Profil Kehamilan</router-link>
                    </li>
                  </ul>
                </div>
              </template>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="row g-4">
              <div class="col-sm-7 col-lg-8 order-2 order-sm-1">
                <div class="row g-0 g-lg-3 align-items-center">
                  <div class="col-lg-4">
                    <label for class="col-form-label">Nama Responden</label>
                  </div>
                  <div class="col-lg-8">
                    <span
                      class="fw-bold fs-5"
                    >{{ safeGet(dataUser, 'user_profile.fullname')}}</span>
                  </div>
                </div>
                <div class="row g-0 g-lg-3 align-items-center mb-3">
                  <div class="col-lg-4">
                    <label for class="col-form-label">NIK / Nomor Penduduk</label>
                  </div>
                  <div class="col-lg-8">
                    <span
                      class="fw-bold"
                    >{{ displayValue(safeGet(dataUser, 'user_profile.nik')) }}</span>
                  </div>
                </div>

                <div class="accordion" id="accordionPanelsStayOpenExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne"
                      >
                        <div class="d-lg-flex gap-3 align-items-center w-100 me-4">
                          <div class="mb-2 mb-lg-0">
                            <div class="small">Nama Kehamilan</div>
                            <label for class="form-label m-0 fs-4">{{safeGet(dataKehamilan[0], 'profile_kehamilan')}}</label>
                          </div>
                          <div class="ms-auto">
                            <div class="small">Tanggal Assessment</div>
                            <label for class="form-label m-0 fs-4">{{latestDate}}</label>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show">
                      <div class="accordion-body">
                        <label for class="form-label">Assessment Kondisi Kejiwaan</label>
                        <hr>
                        <div class="table-responsive">
                          <table class="table table-striped align-middle">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Pertanyaan</th>
                                <th scope="col">Jawaban</th>
                                <th class="text-center" scope="col">Skor</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(req, idx) in latestItems" :key="req.id">
                                <th scope="row">{{ idx + 1 }}</th>
                                <td
                                  class="text-nowrap"
                                >{{req.question}}</td>
                                <td class="text-nowrap">{{req.answer}}</td>
                                <td class="text-center">{{req.score || '-' }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item d-none">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseTwo"
                        aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseTwo"
                      >
                        <div class="d-lg-flex gap-3 align-items-center w-100 me-4">
                          <div class="mb-2 mb-lg-0">
                            <div class="small">Nama Kehamilan</div>
                            <label for class="form-label m-0 fs-4">Anak Keduaku</label>
                          </div>
                          <div class="ms-auto">
                            <div class="small">Tanggal Assessment</div>
                            <label for class="form-label m-0 fs-4">21/08/2025</label>
                          </div>
                        </div>
                      </button>
                    </h2>
                    <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse">
                      <div class="accordion-body">
                        <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It’s also worth noting that just about any HTML can go within the
                        <code>.accordion-body</code>, though the transition does limit overflow.
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-5 col-lg-3 order-1 order-sm-2">
                <div class="bg-success-subtle rounded-4 p-2 shadow-sm  mb-3 text-center">
                  <img
                    v-if="preview != ''"
                    :src="preview"
                    alt="preview"
                    class="img-fluid rounded-3"
                  >
                  <img
                    v-else-if="preview == ''"
                    src="../assets/images/profile/user-7.jpg"
                    class="img-fluid rounded-3"
                    alt="no-img"
                  >
                  <img v-else :src="preview" alt="preview" class="img-fluid rounded-3">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'
import config from "../config";

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			form: {
				assessment_date: '',
				fullname: '',
				hpht: '',
				hpl: '',
				profile_kehamilan: '',
				type: '',
				usia_kehamilan: '',
				tanggal_lahir: '',
				jenis_persalinan: ''
			},
			formPesan: {
				klasifikasi: 'personal',
				responden: '',
				subject: '',
				messages: ''
			},
			penerima: '',
			activeTab: 'activity' // default tab
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		this.$store.dispatch('location/getDataPayload2', {
			url: `users/${this.userId}`
		})

			this.$store
				.dispatch('location/getDataPayload3', {
					url: `user_pregnancies`,
					params: {
						userId: this.userId,
						// offset: this.page - 1,
						limit: 1,
						order: 'desc'
					}
				})

		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataUser: 'location/getDataPayloadObject2',
			dataKejiwaan: 'location/getDataPayload',
			dataKehamilan: 'location/getDataPayload3',
			countDataList: 'location/getCountDCLocation'
		}),
		latestDate() {
			const payload = this.payload || this.dataKejiwaan
			if (!payload || typeof payload !== 'object') return null
			const dates = Object.keys(payload)
			if (!dates.length) return null
			dates.sort((a, b) => b.localeCompare(a))
			return dates[0]
		},
		latestItems() {
			if (!this.latestDate) return []
			return (this.payload || this.dataKejiwaan)[this.latestDate] || []
		},
		latestEntry() {
			// optional: single latest entry by timestamp
			const payload = this.payload || this.dataKejiwaan
			if (!payload) return null
			const all = [].concat(...Object.values(payload)) // safe flatten
			if (!all.length) return null
			return all.reduce((latest, cur) => {
				if (!latest) return cur
				return new Date(cur.assessment_date) > new Date(latest.assessment_date) ? cur : latest
			}, null)
		},
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		},
		preview: {
			// getter
			get() {
				let url = ''
				if (this.dataUser && this.dataUser.user_profile) {
					if (this.dataUser.user_profile.attachment === null || this.dataUser.user_profile.attachment === 'null' || this.dataUser.user_profile.attachment === undefined || this.dataUser.user_profile.attachment === 'undefined' || this.dataUser.user_profile.attachment === '') {
					} else {
						url = config("api.baseUrl") + 'storage/uploads/' + this.dataUser.user_profile.attachment
					}
				} else {
				}
				return url
			},
			set(value) {
				this.dataUser.user_profile.attachment = value
			}
		}
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataPayload', {
					url: `user_assessment/all/${this.userId}`,
					params: {
						section: 'Pertanyaan Kejiwaan',
						userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		detail(assessment_date, userId) {
			let data = this.dataKejiwaan.find((o) => o.assessment_date === assessment_date)
			this.form = {
				assessment_date: assessment_date,
				fullname: data.fullname,
				hpht: data.hpht,
				hpl: data.hpl,
				profile_kehamilan: data.profile_kehamilan,
				type: data.type,
				usia_kehamilan: data.usia_kehamilan,
				tanggal_lahir: data.tanggal_lahir,
				jenis_persalinan: data.jenis_persalinan
			}

			// this.$store.dispatch('location/getDataPayload2', {
			// 	url: `user_assessment/` + userId,
			// 	params: {
			// 		assessment_date: assessment_date
			// 	}
			// })
			this.penerima = data.fullname
			this.formPesan.responden = userId
		}
		// slugify(text) {
		// 	return text.toLowerCase().replace(/\s+/g, '-')
		// },
		// openModalMessage() {
		// 	let data = this.dataList.find((o) => o.assessment_date === assessment_date)
		// 	this.penerima = data.fullname
		// 	this.formPesan.responden = userId
		// },
		// onSubmit() {
		// 	this.$store
		// 		.dispatch('location/createNewRecord', {
		// 			data: this.formPesan,
		// 			url: 'messages/' + this.user_login.id,
		// 			method: 'POST'
		// 		})
		// 		.then((res) => {
		// 			console.log(res)
		// 			let toast = this.$toasted.show(`${res.msg}`, {
		// 				theme: 'bubble',
		// 				position: 'top-right',
		// 				duration: 3000
		// 			})
		// 			if (res.statusCode == 200) {
		// 				this.getDataList()
		// 				document.querySelector('#modalNewMessage [data-bs-dismiss="modal"]').click()
		// 				this.formPesan = {
		// 					klasifikasi: 'Personal',
		// 					responden: '',
		// 					subject: '',
		// 					messages: ''
		// 				}
		// 			} else {
		// 			}
		// 		})
		// }
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
